import { FilterTypes } from "components/Shared/GlobalFilter/types"
import {
	AGE,
	AGE_GROUP_FILTER,
	CHANNEL,
	CHANNEL_GROUP_FILTER,
	GENDER,
	LOCATION_GROUP_FILTER,
	PRODUCT_GROUP_FILTER,
	PSYCHOGRAPHICS,
	PSYCHOGRAPHICS_GROUP_FILTER,
	SEGMENTATION,
} from "components/Shared/GlobalFilter/constants"
import { CustomerProfilingChart, CustomerProfilingTimeline } from "../service"
import { useIntl } from "react-intl"

export const filtersToShow: Array<FilterTypes> = [
	CHANNEL_GROUP_FILTER,
	LOCATION_GROUP_FILTER,
	PRODUCT_GROUP_FILTER,
	AGE_GROUP_FILTER,
	PSYCHOGRAPHICS_GROUP_FILTER,
]

export const disclaimer = {
	id: "phronesis.performance.application.switching.filters.date.disclaimer",
}

export const ID_INFORMATION_TABLE_CUSTOMER_PROFILING =
	"customer-profiling-table"

export interface SelectSegment {
	code: SegmentName
	id: string
}
export type SegmentName = "age" | "gender" | "psychographics"
export const psychographics = "psychographics"
export const psychographicsList = [
	"demanding",
	"optimizer",
	"spontaneous",
	"flexible",
]
export const gender = ["Male", "Female", "Other"]

export const placeholderText = {
	ageSegment:
		"phronesis.customerbehavior.application.customerProfiling.ageSegment",
	genderSegment:
		"phronesis.customerbehavior.application.customerProfiling.genderSegment",
	psychographicsSegment:
		"phronesis.customerbehavior.application.customerProfiling.psychographicsSegment",
	channelSegment:
		"phronesis.customerbehavior.application.customerProfiling.channelSegment",
	ageSegmentDescription:
		"phronesis.customerbehavior.application.customerProfiling.ageSegment.description",
	genderSegmentDescription:
		"phronesis.customerbehavior.application.customerProfiling.genderSegment.description",
	psychographicsSegmentDescription:
		"phronesis.customerbehavior.application.customerProfiling.psychographicsSegment.description",
	channelSegmentDescription:
		"phronesis.customerbehavior.application.customerProfiling.channelSegment.description",
	psychographicsChart:
		"phronesis.customerbehavior.application.customerProfiling.psychographicsChart",
	psychographicsChartDescription:
		"phronesis.customerbehavior.application.customerProfiling.psychographicsChart.description",
	ageChart: "phronesis.customerbehavior.application.customerProfiling.ageChart",
	ageChartDescription:
		"phronesis.customerbehavior.application.customerProfiling.ageChart.description",
	genderChart:
		"phronesis.customerbehavior.application.customerProfiling.genderChart",
	genderChartDescription:
		"phronesis.customerbehavior.application.customerProfiling.genderChart.description",
}

export const SEGMENT_OPTIONS: Array<SelectSegment> = [
	{
		code: "age",
		id:
			"phronesis.customerbehavior.application.customerProfiling.metricsBySegments.select.age",
	},
	{
		code: "gender",
		id:
			"phronesis.customerbehavior.application.customerProfiling.metricsBySegments.select.gender",
	},
	{
		code: "psychographics",
		id:
			"phronesis.customerbehavior.application.customerProfiling.metricsBySegments.select.psychographics",
	},
]

export const tableHeaders = [
	"segment",
	"participation",
	"walmartParticipation",
	"customers",
	"sales",
	"purchaseFrequency",
	"spendByCustomer",
	"avgTicket",
	"itemsPurchased",
	"reach",
]

export const codesCustomerProfiling: Record<string, Array<string>> = {
	[GENDER]: ["female", "male"],
	[AGE]: ["over65", "55to65", "45to54", "35to44", "25to34", "18to24"],
	[CHANNEL]: ["ALL", "STORES", "ECOMMERCE"],
	[SEGMENTATION]: ["cooper", "silver", "gold", "platinum", "new"],
	[PSYCHOGRAPHICS]: ["spontaneous", "optimizer", "flexible", "demanding"],
}

export const dataChartDefault: CustomerProfilingChart = {
	age: [],
	psychographics: [],
	gender: [],
	customerInformation: {
		totalCustomers: 0,
		percentageByCustomers: 0,
	},
}

export const dataTimelineDefault: CustomerProfilingTimeline = {
	interval: "weekly",
	metricName: "transactions",
	data: [],
}

export const renderText = (id: string): any => {
	const intl = useIntl()
	if (gender.includes(id)) {
		return intl.formatMessage({
			id: `phronesis.customerbehavior.application.customerProfiling.chart.gender.${id}`,
		})
	}
	if (psychographicsList.includes(id)) {
		return intl.formatMessage({
			id: `phronesis.customerbehavior.application.customerProfiling.chart.psychographics.${id}`,
		})
	}
	return id
}
